import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { AnimatePresence, motion } from "framer-motion";
import { setSessionData, getSessionData } from "../../cache";
import CryptoJS from "crypto-js";

function BackdoorLogin() {
  const class9ProtectedRoutes = ["/"];

  const [schoolCode, setSchoolCode] = useState("");
  const [schoolPass, setSchoolPass] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [loading, setLoading] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isOtpVerifying, setIsOtpVerifying] = useState(false);

  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");

  const otp1Ref = useRef(null);
  const otp2Ref = useRef(null);
  const otp3Ref = useRef(null);
  const otp4Ref = useRef(null);
  const otp5Ref = useRef(null);
  const otp6Ref = useRef(null);

  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }
  // login pageload API call
  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/FetchConfigurationData`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-Private-Key": tokeng,
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          const configData = data.data; // 🔹 FIXED

          sessionStorage.setItem("class9Active", configData.cL_9_CLASS);
          sessionStorage.setItem(
            "class9DeveloperMode",
            configData.cL_9_DEVELOPER_MODE
          );
          sessionStorage.setItem(
            "class9OtpSchool",
            configData.cL_9_OTP_ON_OFF_SCHOOL
          );
          sessionStorage.setItem(
            "class9BackdoorPhone",
            configData.cL_9_BACKDOOR_PHONE
          );
          sessionStorage.setItem(
            "class9BackdoorEmail",
            configData.cL_9_BACKDOOR_EMAIL
          );
          sessionStorage.setItem(
            "class9DefaultOtp",
            configData.cL_9_DEFAULT_OTP
          );
        } else {
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }
    };

    sessionStorage.clear();
    fetchConfigData();
    generateCaptcha();
  }, []);

  // time use effect
  useEffect(() => {
    let interval;
    if (resendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
      sessionStorage.setItem("LoginOtp", "");
    }
    return () => clearInterval(interval);
  }, [resendDisabled, timer]);
  // Generate random captcha string
  const generateCaptcha = () => {
    const operations = ["+", "-", "*"];
    let num1 = Math.floor(Math.random() * 10); //+ 10;
    let num2 = Math.floor(Math.random() * 10); //+ 10;
    const op = operations[Math.floor(Math.random() * operations.length)];

    if (op === "-" && num1 < num2) {
      [num1, num2] = [num2, num1];
    }

    let answer;
    switch (op) {
      case "+":
        answer = num1 + num2;
        break;
      case "-":
        answer = num1 - num2;
        break;
      case "*":
        answer = num1 * num2;
        break;
    }
    const question = `${num1} ${op} ${num2} = ?`;
    setCaptchaQuestion(question);
    setCaptcha(answer);
    setUserCaptcha("");
    setIsCaptchaValid(false);
    drawCaptcha(question);
  };
  // Draw captcha on canvas
  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Add noise
    for (let i = 0; i < 100; i++) {
      ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        1
      );
    }

    // Captcha text
    ctx.font = "italic bold 28px 'Courier New', monospace";
    ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${
      Math.random() * 100
    })`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  };
  // On captcha input change
  const validateCaptcha = (e) => {
    const val = e.target.value;
    setUserCaptcha(val);
    setIsCaptchaValid(parseInt(val) === captcha);
  };
  const fetchPageLoadData9 = async (token) => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/PageLoadRegistrationData_CL9`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        setLoading(false);
        // console.log("response data:", data);
        setSessionData("blockList", data.data.blockList);
        setSessionData("casteList", data.data.casteList);
        setSessionData("districtList", data.data.districtList);
        setSessionData("divyangList", data.data.divyangList);
        setSessionData("mediumList", data.data.mediumList);
        setSessionData("religionList", data.data.religionList);
        setSessionData("stateList", data.data.stateList);
        setSessionData("language1_2", data.data.languageSubjects || "");
        setSessionData("additional", data.data.additionalSubjects || "");
        setSessionData("compulsary", data.data.compulsorySubjects || "");
        setSessionData(
          "compulsory_one",
          data.data?.compulsorySubjects[0]?.subjecT_ID || ""
        );
        setSessionData(
          "compulsory_two",
          data.data?.compulsorySubjects[1]?.subjecT_ID || ""
        );
        setSessionData(
          "compulsory_three",
          data.data?.compulsorySubjects[2]?.subjecT_ID || ""
        );
        setSessionData(
          "EndDate",
          data.data.cL9EndDate.cL_9_REGISTRATION_END_DATE
        );
        // alert(`Registration End Date: ${data.data.cL9EndDate.cL_9_REGISTRATION_END_DATE}`);
        // alert(`Current Date: ${currentDate}`);
        // console.log(data .data.compulsorySubjects[0].subjecT_NAME);
      } else {
        setLoading(false);
        Swal.fire("Error", data.message || "Invalid response", "error");
      }
    } catch (error) {
      setLoading(false);
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
    }
  };
  // Login handler with captcha validation
  const handleLoginWithCaptcha = async () => {
    if (!schoolCode) {
      Swal.fire("Warning", "Please enter school id.", "warning");
      return;
    }
    if (!schoolPass) {
      Swal.fire("Warning", "Please enter password.", "warning");
      return;
    }
    if (!isCaptchaValid) {
      Swal.fire({
        icon: "error",
        title: "Invalid CAPTCHA",
        text: "Please enter the correct CAPTCHA.",
        confirmButtonColor: "#d33",
      });
      generateCaptcha();
      return;
    }

    await handleLogin();
    generateCaptcha();
  };
  // Login API call
  const handleLogin = async () => {
    setLoading(true);
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/PrincipalAuthenticationSecondary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Private-Key": tokeng,
          },
          body: JSON.stringify({
            loginid: schoolCode,
            password: schoolPass,
            schooL_CODE: "",
          }),
        }
      );

      const data = await response.json();
      // console.log("Login response:", data);
      if (response.ok) {
        // console.log("Login response:", data);
        sessionStorage.setItem("schoolCode", data.data.schooL_CODE);
        sessionStorage.setItem("schoolname", data.data.schooL_NAME);
        sessionStorage.setItem("headMobileNo", data.data.heaD_MOBILE_NO);
        sessionStorage.setItem("schoolEmailId", data.data.emaiL_ADDRESS);
        sessionStorage.setItem("district", data.data.district);
        sessionStorage.setItem(
          "class9profile",
          data.data.admissioN_COUNT_UPD_STS
        );
        handleSentOtp();
        sessionStorage.setItem("tokenclassixwithoutotp", data.data.token);
        await fetchPageLoadData9(data.data.token);
        /* if (sessionStorage.getItem("class9OtpSchool") === "ON") {
          handleSentOtp();
          sessionStorage.setItem("tokenclassixwithoutotp", data.data.token);
        } else {
          sessionStorage.setItem("tokenclassix", data.data.token);
          navigate("/class-ix-dashboard");
        } */
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };
  // Generate new otp
  const generateOTP = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };
  // send otp in  mobile
  const sendMobileOTP = async (contactNumber, otp) => {
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/SendOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: JSON.stringify({
          contactNumber: contactNumber,
          otp: otp,
        }),
      });

      if (response.ok) {
        const result = await response.json();
        // console.log("OTP sent:", result);
        return true;
      } else {
        const error = await response.text();
        console.error("Failed to send OTP:", error);
        return false;
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      return false;
    }
  };
  //Send email OTP API call
  const sendEmailOTP = async (email, otp) => {
    try {
      const tokeng = generateOneTimeToken();
      let message = `Your Login code is ${otp}. Please use this code to complete your Login, JHARKHAND ACADEMIC COUNCIL`;
      const response = await fetch(`${config.API_BASE_URL}/SendMail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: JSON.stringify({
          To: email,
          Subject: "JAC OTP Verification",
          Message: message,
        }),
      });
      const data = await response.json();
      // console.log("Email OTP data:", data);
      if (response.ok && data.success) {
        return true;
      } else {
        const errorText = await response.text();
        console.error("Failed to send Email OTP:", errorText);
        return false;
      }
    } catch (error) {
      console.error("Error sending Email OTP:", error);
      return false;
    }
  };
  //otp sent funtion
  const handleSentOtp = async () => {
    const class9DeveloperMode = sessionStorage.getItem("class9DeveloperMode");
    const schoolCode = sessionStorage.getItem("schoolCode");
    const contact_no = sessionStorage.getItem("class9BackdoorPhone");
    const email_id = sessionStorage.getItem("class9BackdoorEmail");
    const otpStatus = sessionStorage.getItem("class9OtpSchool");

    let otp = "";
    let isSent = false;

    /*if (class9DeveloperMode === "YES") {
      otp = sessionStorage.getItem("class9DefaultOtp");
      isSent = true;
    } else {
      otp = generateOTP();
      isSent = await sendMobileOTP(contact_no, otp);
      isSent = await sendEmailOTP(email_id, otp);
    } */

    if (
      (class9DeveloperMode === "YES" && otpStatus === "ON") ||
      (class9DeveloperMode === "YES" && otpStatus === "OFF") ||
      (class9DeveloperMode === "NO" && otpStatus === "OFF")
    ) {
      otp = sessionStorage.getItem("class9DefaultOtp");
      isSent = true;
    } else if (class9DeveloperMode === "NO" && otpStatus === "ON") {
      otp = generateOTP();
      const smsSent = await sendMobileOTP(contact_no, otp);
      const emailSent = await sendEmailOTP(email_id, otp);
      isSent = smsSent && emailSent;
    }

    if (isSent) {
      const conOtp = `${schoolCode}|${otp}`;
      sessionStorage.setItem("LoginOtp", conOtp);
      setOtp1("");
      setOtp2("");
      setOtp3("");
      setOtp4("");
      setOtp5("");
      setOtp6("");
      setShowOtpModal(true);
      setResendDisabled(true);
      otp1Ref.current?.focus();
      setTimer(180);
    } else {
      Swal.fire("Error", "Failed to send OTP. Please try again.", "error");
    }
  };
  // otp input function
  const handleOtpInput = (e, setPart, maxLength, nextRef) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, maxLength);
    setPart(value);
    if (value.length === maxLength && nextRef?.current) {
      nextRef.current.focus();
    }
  };
  // otp remove function
  const handleOtpBackspace = (e, value, prevRef) => {
    if (e.key === "Backspace" && value === "" && prevRef?.current) {
      prevRef.current.focus();
    }
  };
  // otp verify function
  const handleOtpVerify = () => {
    setIsOtpVerifying(true);
    const otp = [otp1, otp2, otp3, otp4, otp5, otp6].join("");
    let LoginOtp = sessionStorage.getItem("LoginOtp");
    let schoolCode = sessionStorage.getItem("schoolCode");
    let tokenclassixwithoutotp = sessionStorage.getItem(
      "tokenclassixwithoutotp"
    );

    if (LoginOtp !== null && LoginOtp !== "") {
      let [extractedschoolCode, extractedOtp] = LoginOtp.split("|");

      if (otp.length !== 6) {
        Swal.fire(
          "Warning",
          "Please enter all 6 digits of the OTP.",
          "warning"
        );
        setIsOtpVerifying(false);
        return;
      }

      if (schoolCode === extractedschoolCode && otp === extractedOtp) {
        sessionStorage.setItem("tokenclassix", tokenclassixwithoutotp);
        sessionStorage.removeItem("tokenclassixwithoutotp");
        sessionStorage.removeItem("class9BackdoorPhone");
        sessionStorage.removeItem("class9BackdoorEmail");
        sessionStorage.removeItem("class9DefaultOtp");
        sessionStorage.removeItem("schoolEmailId");
        // sessionStorage.removeItem("headMobileNo");
        sessionStorage.removeItem("LoginOtp");
        sessionStorage.removeItem("class9DeveloperMode");
        sessionStorage.removeItem("class9OtpSchool");
        navigate("/class-ix-dashboard");
      } else {
        Swal.fire("Error", "Invalid OTP. Please try again.", "error");
        setIsOtpVerifying(false);
        return;
      }
    } else {
      Swal.fire("Error", "Invalid OTP. Please try again.", "error");
      setIsOtpVerifying(false);
      return;
    }
  };
  // otp model colse funtion
  const handlemodalclose = () => {
    setShowOtpModal(false);
    sessionStorage.removeItem("schoolname");
    sessionStorage.removeItem("headMobileNo");
    sessionStorage.removeItem("district");
    sessionStorage.removeItem("schoolEmailId");
    sessionStorage.removeItem("tokenclassixwithoutotp");
    sessionStorage.removeItem("LoginOtp");
    sessionStorage.removeItem("schoolCode");
    setOtp1("");
    setOtp2("");
    setOtp3("");
    setOtp4("");
    setOtp5("");
    setOtp6("");
  };

  return (
    <div className="container-scroller">
      {/* Header section */}
      <header id="header" class="fixed-top login-bg">
        <div class="container">
          <div class="d-flex align-items-center" style={{ margin: "10px 0px" }}>
            <div>
              <img
                src="assets/images/jac-academic-council.png"
                style={{ height: "75px" }}
              />
              &nbsp;&nbsp;&nbsp;
            </div>
            <div>
              <h2
                class="logo"
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Jharkhand Academic Council, Ranchi
              </h2>
              <h4
                class="logo"
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Class IX Examination, Year 2026 (Annual)
              </h4>
            </div>
          </div>
        </div>
      </header>
      {/* login form section */}
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="container">
            <div className="row w-100">
              <div className="col-md-1"></div>

              <div
                class="col-lg-6"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                }}
              >
                <h1 style={{ lineHeight: "5rem" }}>
                  Class IX Registration Portal
                </h1>
                <br />
                <marquee
                  class="marq"
                  style={{
                    color: "red",
                    fontWeight: 500,
                    padding: "10px",
                    marginBottom: "10px",
                    borderRadius: "10px",
                    fontSize: "20px",
                  }}
                  direction="left"
                  loop=""
                >
                  सभी लॉगिन संबंधित OTP SMS आपके पंजीकृत फोन नंबर और ई-मेल -
                  दोनों पर भेजे जाएंगे। All Login related SMS OTP will go to
                  your registered phone and&nbsp;e-mail,&nbsp;BOTH.
                </marquee>
              </div>

              <div className="col-lg-4">
                <div className="auth-form-light text-left py-3 px-3">
                  {/* <h4 className="text-center mb-3">Student Login</h4> */}
                  <form
                    className="pt-2"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleLoginWithCaptcha();
                    }}
                  >
                    <div className="form-group">
                      <h6 className="font-weight-light">Enter School ID</h6>
                      <input
                        type="text"
                        maxLength={5}
                        className="form-control form-control-xs"
                        placeholder="Enter School ID"
                        value={schoolCode}
                        onChange={(e) =>
                          setSchoolCode(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                    </div>

                    <div className="form-group">
                      <h6 className="font-weight-light">Enter Password</h6>
                      <input
                        type="password"
                        className="form-control form-control-xs"
                        placeholder="Enter Password"
                        value={schoolPass}
                        onChange={(e) => setSchoolPass(e.target.value)}
                      />
                    </div>

                    <div className="form-group mb-3 text-center">
                      <canvas
                        ref={canvasRef}
                        width="200"
                        height="40"
                        style={{ border: "1px solid #ddd" }}
                      />
                      <button
                        type="button"
                        onClick={generateCaptcha}
                        className="btn btn-secondary ms-2"
                        style={{ marginTop: "-33px" }}
                      >
                        ↻ Refresh
                      </button>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Enter CAPTCHA</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Enter CAPTCHA"
                        value={userCaptcha}
                        onChange={validateCaptcha}
                      />
                    </div>

                    <div className="mt-1">
                      <button
                        type="submit"
                        className="btn btn-block bg-danger btn-xs text-white"
                        style={{ padding: "10px" }}
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer section */}
      <footer
        class="fixed-bottom login-bg"
        style={{ textAlign: "center", padding: "8px 0px", color: "white" }}
      >
        <p style={{ marginBottom: "0px", fontSize: "12px" }}>
          Best viewed in all modern browsers (latest versions): Chrome 120+,
          Firefox 123+ Recommended minimum resolution: 1366 x 768
        </p>
        <p style={{ marginBottom: "0px", fontSize: "12px" }}>
          Please do not access this portal from any mobile devices
        </p>
        <p style={{ marginBottom: "0px", fontSize: "12px" }}>
          © Copyright JAC 2025. All rights reserved.
        </p>
      </footer>
      {/* Otp modal section */}
      <AnimatePresence>
        {showOtpModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                width: "95%",
                maxWidth: "500px",
                borderRadius: "12px",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleOtpVerify();
                }}
              >
                <div className="modal-header" style={{ padding: "10px" }}>
                  <h5 className="modal-title">OTP Verification</h5>
                  <button
                    type="button"
                    className="btn close"
                    aria-label="Close"
                    onClick={() => {
                      handlemodalclose();
                    }}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div
                  className="modal-body"
                  style={{ padding: "15px", border: "1px solid lightgray" }}
                >
                  <div className="text-center mb-3">
                    <h6 className="font-weight-light">
                      OTP sent on mobile: ******
                      {sessionStorage.getItem("class9BackdoorPhone")?.slice(-4)}
                    </h6>
                  </div>
                  <div className="row" style={{ padding: "0px 25px" }}>
                    {[
                      {
                        ref: otp1Ref,
                        value: otp1,
                        set: setOtp1,
                        next: otp2Ref,
                        prev: null,
                      },
                      {
                        ref: otp2Ref,
                        value: otp2,
                        set: setOtp2,
                        next: otp3Ref,
                        prev: otp1Ref,
                      },
                      {
                        ref: otp3Ref,
                        value: otp3,
                        set: setOtp3,
                        next: otp4Ref,
                        prev: otp2Ref,
                      },
                      {
                        ref: otp4Ref,
                        value: otp4,
                        set: setOtp4,
                        next: otp5Ref,
                        prev: otp3Ref,
                      },
                      {
                        ref: otp5Ref,
                        value: otp5,
                        set: setOtp5,
                        next: otp6Ref,
                        prev: otp4Ref,
                      },
                      {
                        ref: otp6Ref,
                        value: otp6,
                        set: setOtp6,
                        next: null,
                        prev: otp5Ref,
                      },
                    ].map((field, index) => (
                      <div
                        className="col-2"
                        key={index}
                        style={{ padding: "0px 10px" }}
                      >
                        <input
                          type="tel"
                          ref={field.ref}
                          value={field.value}
                          onChange={(e) =>
                            handleOtpInput(e, field.set, 1, field.next)
                          }
                          onKeyDown={(e) =>
                            handleOtpBackspace(e, field.value, field.prev)
                          }
                          className="form-control form-control-sm text-center number"
                          maxLength="1"
                          pattern="[0-9]*"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          autoFocus={index === 0}
                        />
                      </div>
                    ))}
                  </div>
                  <p
                    id="timer"
                    className="text-center text-danger"
                    style={{ margin: "5px 0px" }}
                  >
                    {resendDisabled
                      ? `Resend in ${timer} seconds`
                      : "You can resend OTP now"}
                  </p>
                </div>

                <div
                  className="modal-footer"
                  style={{ padding: "10px", display: "flex", gap: "5px" }}
                >
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={handleSentOtp}
                    disabled={resendDisabled}
                  >
                    <i className="fa fa-refresh"></i>&nbsp;Resend OTP
                  </button>

                  <button
                    type="submit"
                    className={`btn text-white ${
                      isOtpVerifying ? "bg-danger" : "bg-brown"
                    }`}
                    disabled={isOtpVerifying}
                  >
                    <i
                      className={`fa ${
                        isOtpVerifying ? "fa-refresh fa-spin" : "fa-check"
                      }`}
                    ></i>
                    &nbsp;
                    {isOtpVerifying ? "Verifying ..." : "Verify OTP"}
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default BackdoorLogin;
